import {
  OnboardingStore,
  OnboardingStoreType
} from '@blisspointmedia/bpm-types/dist/ClientOracleOnboarding';
import { Background } from '@Components/designConstants';
import { SegmentedControlButton } from '@Components/SegmentedControlButton';

const STORE_OPTIONS = [
  { key: OnboardingStore.TINUITI, label: 'Tinuiti' },
  { key: OnboardingStore.ASSEMBLE, label: 'Assemble' }
];

interface StoreToggleProps {
  store: OnboardingStoreType;
  setStore: (store: OnboardingStoreType) => void;
  canOverride: boolean;
}

// Switches which store the page reads and writes.
export const StoreToggle = ({ store, setStore, canOverride }: StoreToggleProps) => {
  if (!canOverride) {
    return null;
  }
  return (
    <SegmentedControlButton
      options={STORE_OPTIONS}
      selectedOption={store}
      onChange={setStore}
      background={Background.DARK}
    />
  );
};
